import type { WhatsNewBody } from '../types';

export default {
  title: 'A Photos tab on every job',
  summary:
    'A job’s site photos now have their own Photos tab under Documents, with month navigation and search. It is the same feed the Daily Logs tab shows, which now calls its switch Photos too.',
  details: [
    'Pick a month, or search, to find an older photo.',
    'Photos put straight into SharePoint don’t show in the feed.',
  ],
  tryIt: { to: '/projects', label: 'Open Projects' },
  image: {
    file: 'photos-tab.png',
    alt: 'The top of the Photos tab, with a search box, Month and Posted by filters, From and To dates, and an Add photos button.',
  },
  guide: { topic: 'mod-photos-one-feed' },
} satisfies WhatsNewBody;
